var map = {
	"./arrow-back.svg": 289,
	"./bg-basel.png": 682,
	"./bg-basel_1200.png": 754,
	"./bg-basel_with_river.png": 692,
	"./bg-switzerland.png": 192,
	"./bg-switzerland_1200.png": 831,
	"./button-blue.png": 579,
	"./button-blue_1200.png": 389,
	"./button-green.png": 651,
	"./button-green_1200.png": 409,
	"./button-home.png": 369,
	"./button-home_1200.png": 72,
	"./button-switzerland.png": 352,
	"./button-switzerland_1200.png": 273,
	"./button-yellow.png": 328,
	"./button-yellow_1200.png": 315,
	"./home-icon.svg": 640,
	"./scroll-arrow.svg": 772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;